import shallowEqual from './shallowEqual';

export default function shouldPureComponentUpdate(nextProps, nextState) {
  return !shallowEqual(this.props, nextProps) ||
         !shallowEqual(this.state, nextState);
}


/** WEBPACK FOOTER **
 ** ./examples/02 Drag Around/Custom Drag Layer/shouldPureComponentUpdate.js
 **/